import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
  codeHitsAllowed: 0,
  examEndTime:0
};

const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    setAllowedHits: (state, action: PayloadAction<number>) => {
      state.codeHitsAllowed = action.payload;
    },
    decreaseCount: (state) => {
      if (state.codeHitsAllowed > 0) {
        state.codeHitsAllowed -= 1;
      }
    },
    increaseCount: (state) => {
      state.codeHitsAllowed += 1;
    },

    resetHits: (state) => {
      state.codeHitsAllowed = initialState.codeHitsAllowed;
    },
    setExamEndTime: (state, action: PayloadAction<number>) => {
      state.examEndTime = action.payload;
    },
    resetExamEndTime: (state) => {
      state.examEndTime = initialState.examEndTime;
    }
  },
});
export const codeHitsAllowed = (state: RootState) =>
  state?.exam?.codeHitsAllowed || 0;
export const { setAllowedHits, decreaseCount, resetHits,setExamEndTime,resetExamEndTime } = examSlice.actions;
export default examSlice.reducer;
